import { iconSet, iconsWithoutBackground } from './IconLibrary';

export const IconNames: string[] = Object.keys(iconSet);
export type FillColour = 'default' | 'neutral' | 'primary' | 'secondary' | 'transparent';

type StrokeColour = 'primary' | 'neutral' | 'secondary' | 'dark';

export const FillColours: FillColour[] = ['default', 'neutral', 'primary', 'secondary', 'transparent'];

interface IconProps {
  fillColour?: FillColour;
  strokeColour?: StrokeColour;
  name: string;
  size?: number;
}

export const Icon = ({ name, fillColour = 'default', strokeColour = 'neutral', size = 32 }: IconProps) => {
  // See src/components/ui/Icon/Icon.registry.ts, iconInput adds a "None" option to the enum list.
  if (name === '' || !iconSet[name]) {
    return null;
  }

  const Content = iconSet[name];
  const classList = [
    `min-w-12 w-12 h-12 rounded-[8px] flex group-[.dark]:text-dark-200 group-[.dark]:bg-neutral items-center justify-center text-${strokeColour}`,
  ];

  if (!iconsWithoutBackground.includes(name)) {
    classList.push('tc-icon');
  }

  if (fillColour !== 'default') {
    classList.push(`bg-${fillColour}`);
  }

  return (
    <span className={classList.join(' ')}>
      <Content aria-hidden="true" size={size} />
    </span>
  );
};
